import { OrgAuthForgotPasswordPage } from "@solomon-apps/shared";
import React from "react";

import { CLIENT_OAUTH_CONFIG } from "@/constants/oauthConfig";

export function ForgotPasswordPage(): React.ReactElement {
    return (
        <OrgAuthForgotPasswordPage
            apiBase={CLIENT_OAUTH_CONFIG.apiBase}
            footerNote="Access is restricted to authorised company recipients only."
        />
    );
}
